import React from 'react';
import {Col, Row} from 'reactstrap';
import assets from '../../util/assets';

const SectionHeader = (props) => {
    const { title, currentPage, lastPage } = props;
    return (
        <Row>
            <Col sm="6" className="text-left sectionheadertitle">{title.toUpperCase()}</Col>
            <Col sm="6" className="text-right">
                <span className="mr-2" style={{paddingRight: 16}}>View all</span>
                <span style={{paddingRight: 16, cursor: 'pointer'}}><img
                    src={currentPage && currentPage === 1 ? assets.left_arrow_disable : assets.left_arrow_enable}
                    onClick={() => {
                        props.previous(currentPage !== 1 && currentPage - 1)
                    }}/></span>
                <span style={{paddingRight: 16, cursor: 'pointer'}}><img
                    src={(currentPage && currentPage) === (lastPage && lastPage) ? assets.right_arrow_disable : assets.right_arrow_enable}
                    onClick={() => {
                        props.next(currentPage !== lastPage && currentPage + 1)
                    }}/></span>
                {/*<i className={ currentPage && currentPage === 1 ? "fa fa-arrow-left mr-2 view-all-left-disabled" : "fa fa-arrow-left mr-2 view-all-left"} aria-hidden="true" onClick={()=>{props.previous(currentPage !== 1 && currentPage-1)}}></i>*/}
                {/*<i className={(currentPage && currentPage) === (lastPage && lastPage) ? "fa fa-arrow-right view-all-right-disabled" :  "fa fa-arrow-right view-all-right"} aria-hidden="true" onClick={()=>{props.next(currentPage !== lastPage && currentPage+1)}}></i>*/}
            </Col>
        </Row>
    );
}

export default SectionHeader;